import type React from 'react';

import { IconClock } from '@xing-com/icons';

import { TrackingLink } from '../../tracking-link';

import {
  Card,
  DesktopContainer,
  Image,
  Link,
  OuterWrapper,
  ReadingTimeWrapper,
  ReadingTime,
} from './article-card.styles';

type ArticleCard = {
  section: string;
  data: {
    image: string;
    articleUrl: string;
    thumbnail: string;
    readingTime: string;
    section: string;
  };
};

export const ArticleCard: React.FC<ArticleCard> = ({ data, section }) => {
  return (
    <Card>
      <Image src={data.image} alt={`${section} image`} />
      <DesktopContainer>
        <TrackingLink
          as={Link}
          url={data.articleUrl}
          trackingParams={{
            sc_o: `career_hub_application_home_article_click`,
            sc_o_PropActionOrigin: `career_hub_application_home_${section}_section`,
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {data.thumbnail}
        </TrackingLink>
        <OuterWrapper>
          <ReadingTimeWrapper>
            <IconClock height={24} width={24} />
            <ReadingTime>{data.readingTime}</ReadingTime>
          </ReadingTimeWrapper>
        </OuterWrapper>
      </DesktopContainer>
    </Card>
  );
};
